/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 14C20.2927 14.6904 22 16.1241 22 17.7807C22 20.111 17.5228 22 12 22C6.47715 22 2 20.111 2 17.7807C2 16.1241 3.70729 14.6904 7 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 12L12 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="12" cy="7" r="5" fill="currentColor" />
			<path
				d="M17 14C20.2927 14.6904 22 16.1241 22 17.7807C22 20.111 17.5228 22 12 22C6.47715 22 2 20.111 2 17.7807C2 16.1241 3.70729 14.6904 7 14M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 12V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.748 11.9444C15.1546 11.5834 17 9.50722 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.50722 8.84541 11.5834 11.252 11.9444C11.2507 11.9628 11.25 11.9813 11.25 12V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V12C12.75 11.9813 12.7493 11.9628 12.748 11.9444ZM7.15391 14.734C7.55931 14.649 7.81904 14.2515 7.73404 13.8461C7.64903 13.4407 7.25148 13.181 6.84609 13.266C5.13419 13.6249 3.7643 14.1901 2.80491 14.9359C1.83474 15.6901 1.25 16.6632 1.25 17.7807C1.25 18.6211 1.65685 19.3562 2.25617 19.954C2.85259 20.549 3.67771 21.0503 4.63737 21.4552C6.55971 22.2663 9.16326 22.75 12 22.75C14.8367 22.75 17.4403 22.2663 19.3626 21.4552C20.3223 21.0503 21.1474 20.549 21.7438 19.954C22.3431 19.3562 22.75 18.6211 22.75 17.7807C22.75 16.6632 22.1653 15.6901 21.1951 14.9359C20.2357 14.1901 18.8658 13.6249 17.1539 13.266C16.7485 13.181 16.351 13.4407 16.266 13.8461C16.181 14.2515 16.4407 14.649 16.8461 14.734C18.4269 15.0655 19.557 15.5624 20.2744 16.1201C20.9811 16.6695 21.25 17.2416 21.25 17.7807C21.25 18.1054 21.0972 18.4803 20.6845 18.8921C20.2688 19.3067 19.6295 19.7146 18.7795 20.0732C17.0826 20.7892 14.6861 21.25 12 21.25C9.31389 21.25 6.91744 20.7892 5.22049 20.0732C4.37051 19.7146 3.73117 19.3067 3.31553 18.8921C2.90279 18.4803 2.75 18.1054 2.75 17.7807C2.75 17.2416 3.01891 16.6695 3.72556 16.1201C4.443 15.5624 5.57311 15.0655 7.15391 14.734Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 14C20.2927 14.6904 22 16.1241 22 17.7807C22 20.111 17.5228 22 12 22C6.47715 22 2 20.111 2 17.7807C2 16.1241 3.70729 14.6904 7 14M12 12C14.7614 12 17 9.76142 17 7C17 6.65753 16.9656 6.32311 16.9 6M12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C12.7111 2 13.3875 2.14845 14 2.41604M12 12V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 14C20.2927 14.6904 22 16.1241 22 17.7807C22 20.111 17.5228 22 12 22C6.47715 22 2 20.111 2 17.7807C2 16.1241 3.70729 14.6904 7 14M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 12V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V12C11.25 11.5858 11.5858 11.25 12 11.25ZM7.73404 13.8461C7.81904 14.2515 7.55931 14.649 7.15391 14.734C5.57311 15.0655 4.443 15.5624 3.72556 16.1201C3.01891 16.6695 2.75 17.2416 2.75 17.7807C2.75 18.1054 2.90279 18.4803 3.31553 18.8921C3.73117 19.3067 4.37051 19.7146 5.22049 20.0732C6.91744 20.7892 9.31389 21.25 12 21.25C14.6861 21.25 17.0826 20.7892 18.7795 20.0732C19.6295 19.7146 20.2688 19.3067 20.6845 18.8921C21.0972 18.4803 21.25 18.1054 21.25 17.7807C21.25 17.2416 20.9811 16.6695 20.2744 16.1201C19.557 15.5624 18.4269 15.0655 16.8461 14.734C16.4407 14.649 16.181 14.2515 16.266 13.8461C16.351 13.4407 16.7485 13.181 17.1539 13.266C18.8658 13.6249 20.2357 14.1901 21.1951 14.9359C22.1653 15.6901 22.75 16.6632 22.75 17.7807C22.75 18.6211 22.3431 19.3562 21.7438 19.954C21.1474 20.549 20.3223 21.0503 19.3626 21.4552C17.4403 22.2663 14.8367 22.75 12 22.75C9.16326 22.75 6.55971 22.2663 4.63737 21.4552C3.67771 21.0503 2.85259 20.549 2.25617 19.954C1.65685 19.3562 1.25 18.6211 1.25 17.7807C1.25 16.6632 1.83474 15.6901 2.80491 14.9359C3.7643 14.1901 5.13419 13.6249 6.84609 13.266C7.25148 13.181 7.64903 13.4407 7.73404 13.8461Z"
				fill="currentColor"
			/>
			<circle cx="12" cy="7" r="5" fill="currentColor" />
		</Fragment>,
	],
]);
